import script from "./MyTasksView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTasksView.vue?vue&type=script&setup=true&lang=js"

import "./MyTasksView.vue?vue&type=style&index=0&id=a3ef04ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3ef04ec"]])

export default __exports__